import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import PageHero from "@/components/layout/PageHero";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import { Clock, IndianRupee, FileText, ArrowRight } from "lucide-react";

export default function VisaGuides() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/visa-guides").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  return (
    <div data-testid="visa-guides-page">
      <PageHero
        kicker="Visa Guides"
        title="Visa rules made simple, country by country"
        subtitle="Step-by-step visa guides for Indian passport holders — documents, processing time, fees and tips."
      />
      <div className="container-page py-10">
        <Breadcrumbs items={[{ label: "Visa Guides" }]} />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((v) => (
            <Link key={v.slug} to={`/visa-guides/${v.slug}`} data-testid={`visa-${v.slug}`} className="group bg-white border border-slate-200 rounded-2xl overflow-hidden card-hover">
              <div className="h-44 relative overflow-hidden">
                <img src={v.image} alt={v.country} className="w-full h-full object-cover img-zoom" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent" />
                <div className="absolute bottom-3 left-3 text-white">
                  <div className="font-montserrat font-bold text-lg">{v.country}</div>
                  <div className="text-[11px] text-white/85">{v.visa_type}</div>
                </div>
              </div>
              <div className="p-5">
                <div className="grid grid-cols-2 gap-3 text-xs">
                  <div className="inline-flex items-center gap-1.5 text-slate-600"><Clock size={12} className="text-brand" /> {v.processing_time}</div>
                  <div className="inline-flex items-center gap-1.5 text-slate-600"><IndianRupee size={12} className="text-brand" /> {v.fees_inr}</div>
                  <div className="inline-flex items-center gap-1.5 text-slate-600 col-span-2"><FileText size={12} className="text-brand" /> Valid {v.validity}</div>
                </div>
                <div className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-brand group-hover:gap-2 transition-all">
                  Read full guide <ArrowRight size={14} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
